<template>
  <div
    v-if="searchTerm"
    :class="{ disabled: isDisabled }"
    class="search-filter-button"
  >
    <v-icon
      icon="$magnify"
      class="decor pl-1"
      :size="20"
    />
    <p class="button-content">
      "{{ searchTerm }}"
    </p>
    <button
      class="remove-search-button pr-1"
      type="button"
      @click.stop="handleRemoveSearchTerm()"
    >
      <v-icon icon="$close" :size="14" />
    </button>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { useFilters } from '@/stores/filters/filters';

defineProps({
  isDisabled: { type: Boolean, default: false },
});

// Router
const router = useRouter();
const route = useRoute();

// Stores
const filtersStore = useFilters();
const { searchTerm } = storeToRefs(filtersStore);
const { submitSearchTerm } = filtersStore;

// Methods
const handleRemoveSearchTerm = (btn) => {
  if (btn && searchTerm.value) return;
  const jobProfileRoutes = ['published-job-profiles', 'draft-job-profiles'];
  const dateSort = route.name === 'open-requisitions' ? '-opened_at' : '-closed_at';
  const defaultSort = route.name.includes('requisitions') ? dateSort : 'relevance';
  const clearSort = jobProfileRoutes.includes(route.name) ? 'title' : undefined;

  submitSearchTerm({
    searchTerm: null, router, defaultSort, clearSort,
  });
};
</script>

<style lang="less" scoped>
.search-filter-button{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  height: 36px;
  border: 1px solid @stroke-default;
  background-color: @bg-brand-light;
  border-radius: 32px;
  padding: 0 4px;

  &.disabled {
    pointer-events: none;
    filter: grayscale(100%);
  }

  p {
    color: @text-brand;
  }

  :deep(.decor) path {
   fill: @icon-brand;
  }
}

.button-content {
  font-size: 13px;
  font-weight: 500;
}

.remove-search-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  margin-left: 4px;
  border-radius: 50%;

  :deep(.v-icon) path {
    fill: @icon-default;
  }

  &:hover {
    cursor: pointer;
  }
}
</style>
